module.exports = __webpack_public_path__ + "img/balances-plans.54e37a91.svg";